import homeIcon from '~/assets/img/icon/home.svg';
import myBidsIcon from '../../assets/img/icon/menu/my_bids.svg';
import myJobListingsIcon from '../../assets/img/icon/menu/my_job_listings.svg';
import settingIcon from '../../assets/img/icon/menu/setting.svg';

// Base routes for authenticated users
const AUTH_ROUTES = [
  {
    title: 'Notifications',
    mdi: true,
    icon: 'mdi-bell-outline',
    link: { name: 'notifications' },
    mobileOnly: true,
  },
  {
    title: 'My Job Listings',
    icon: myJobListingsIcon,
    link: { name: 'my-listings' },
  },
  {
    title: 'My Bids',
    icon: myBidsIcon,
    link: { name: 'my-bids' },
  },
  {
    title: 'Settings',
    icon: settingIcon,
    link: { name: 'account-settings' },
  },
];

// Helper function to get filtered routes based on screen size
const getAuthRoutes = (isLargeScreen: boolean) => {
  return AUTH_ROUTES.filter((route) => !route.mobileOnly || !isLargeScreen);
};

const GUEST_ROUTES = [
  // Module: Post Feed
  // Uncomment the links here for Post Feed
  {
    title: 'Home',
    link: { name: 'index' },
    icon: homeIcon,
  },
];

export { AUTH_ROUTES, GUEST_ROUTES, getAuthRoutes };
